import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import { Typography, Breadcrumbs, Link, Box, Tabs, Tab, Button } from "@mui/material";
import { TABS } from "../../../config/tabConfig";
import Header from "./Header";
import { useAppContext } from '../../../hooks/context/AppContext';
import "./layout.css";
import {
  IconButton,
} from "@mui/material";
import { Add, ViewList, GridView, Home } from "@mui/icons-material";
import Grid from '@mui/material/Grid2';
import { useProjectApiClient } from "../../Services/api/projectService";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { projectVersion } from "config/navConfig";
import historyIcon from "../../../assets/images/history-icon.svg";


const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const { projectId, projectKey } = useParams(); // Get projectId from URL
  const location = useLocation();
  const { appData, updateAppData } = useAppContext();
  // Retrieve project details from localStorage
  const [projectDetails] = useLocalStorage("ProjectDetails", null);
  const [projectName, setProjectName] = useState("");
  const { getProjectName } = useProjectApiClient();
  // Initialize projectName state
  useEffect(() => {
    const localProjectName = (() => {
      try {
        return JSON.parse(projectDetails || "{}").projectName || "";
      } catch (e) {
        console.error("Failed to parse projectDetails:", e);
        return "";
      }
    })();
    if (localProjectName) {
      setProjectName(localProjectName);
    } else {
      // If not found in localStorage, fetch from API
      const fetchProjectName = async () => {
        const data = await getProjectName(projectId);
        if (data) {
          setProjectName(data);
        }
      };
      fetchProjectName();
    }
  }, [projectDetails, projectId]);


  // Find active tab index
  const activeTab = location.pathname === `${projectVersion}/create-project`
    ? TABS.findIndex((tab) => tab.path === `${projectVersion}/project-info`)
    : TABS.findIndex((tab) => location.pathname.includes(tab.path));


  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (location.pathname === `${projectVersion}/create-project` && TABS[newValue].path !== `${projectVersion}project-info`) {
      return;
    }
    if (projectId) {
      const searchParams = new URLSearchParams(location.search);
      const uploadFlag = searchParams.get("isUpload") === "true";
      let url = `${projectVersion}/project/${TABS[newValue].path}/${projectId}/${projectKey}`
      if (uploadFlag) {
        url = `${projectVersion}/project/${TABS[newValue].path}/${projectId}/${projectKey}?isUpload=true&moduleId=${newValue + 1}`
      }
      if (!appData.isFormChanged) {
        navigate(url);
      } else {
        updateAppData({ isFormChanged: true, showUnSavedModal: true, url: url });
      }
    } else {
      if (!appData.isFormChanged) {
        navigate(`${projectVersion}/project/${TABS[newValue].path}`);
      } else {
        updateAppData({ isFormChanged: true, showUnSavedModal: true, url: `${projectVersion}/project/${TABS[newValue].path}` });
      }
    }
  };

  let handleHomeClick = () => {
    if (!appData.isFormChanged) {
      localStorage.removeItem("ProjectDetails");
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: `${projectVersion}/projects-grid` });
    }
  }
  let handleLandingClick = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/`);
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: `/${projectVersion}/` });
    }
  }
  return (
    <Box sx={{ height: "100vh", position: "relative" }}>
      {/*  Use HomeHeader */}
      <Header />
      {/* <Box sx={{ display: "flex", height: "auto", bgcolor: "#F5F5F5" }}> */}
      <Box sx={{ display: "flex", height: "auto" }}>
        {/* Sidebar + Breadcrumbs Container */}
        <Box sx={{ width: 250, color: "#fff", display: "flex", flexDirection: "column" }}>
          {/* Breadcrumbs Above the Sidebar */}

          {/* Sidebar Navigation */}
          <div className="leftMenu-containe">
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={activeTab}
              onChange={handleTabChange}
              sx={{ position: 'relative', marginRight: "-20px", color: "#fff", "& .Mui-selected": { bgcolor: "#FFF", color: "#0D47A1", borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }, p: 2 }}
            >
              {TABS.map((tab, index) => (

                <Tab
                  key={index}
                  label={tab.label}
                  sx={{
                    textAlign: "left",
                    float: "left",
                    flexFlow: "row",
                    color: "#fff",
                    textTransform: "none",
                    fontSize: 12,
                    p: 1.5,
                    "&.Mui-selected": { fontWeight: "bold", boxShadow: "0px 0px 6px 0px #333" },
                  }}
                />
              ))}
            </Tabs>
          </div>
        </Box>

        {/* Main Content */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }} className="flex-widt-side">
          {/* Top Navigation Bar */}
          <div className="breadcrumb-container"
          // style={{
          //   position: 'sticky', top: '60px',
          //   background: '#f5f5f5' ,
          //   zIndex: 1
          // }}
          >

            <Grid container spacing={3}>
              <Grid size={6}>
                <Breadcrumbs aria-label="breadcrumb">
                  <IconButton onClick={() => handleLandingClick()} sx={{ color: "#003399" }}>
                    <Home fontSize="medium" />
                  </IconButton>
                  <Link underline="hover" color="inherit" onClick={() => handleHomeClick()} sx={{ fontSize: "13px" }}>
                    Back to List
                  </Link>
                  <Typography color="text.primary" sx={{ fontSize: "13px" }}>
                    {location.pathname.includes(`${projectVersion}/create-project`)
                      ? 'Create New Project'
                      : `${projectName} - ${TABS.find(tab => location.pathname.includes(tab.path))?.label || 'Project Information'}`}
                  </Typography>
                </Breadcrumbs>
              </Grid>
              <Grid size={6}>
                {
                  !location.pathname.includes("create-project") ?
                    <div onClick={() => navigate(`/v2/project/project-info/history/${projectId}/${projectKey}`)} className="history-button"><Button sx={{ backgroundColor: '#D9D9D9', border: '1px solid #CBCBCB', borderRadius: '30px', width: '145px', fontSize: '14px', color: '#000', textTransform: 'capitalize' }}><img src={historyIcon} className="height-auto history-icon" /> Show History</Button></div>
                    :
                    null
                }
              </Grid>
            </Grid>


          </div>
          {/* Page Content */}
          <Box sx={{ flex: 1, p: 2, overflowY: "inherit" }}>
            {/* <Box sx={{ flex: 1, p: 4 }}> */}
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
